// Norge
export default {
	status: {
		All: "Alle",
		Pending: "Avventende",
		Frozen: "Frossen",
		Completed: "Fullført",
		Undone: "Ugjort"
	},
	TotalAmount: "Totalbeløp",
	Profit: "Fortjeneste",
	Expire: "Utløpe"
};
